module.exports = __webpack_public_path__ + "img/Oracle.a0fe39a7.png";